export const a4PrintConfig = `
  @page {
    size: A4 portrait;
    margin: 0mm 12mm 0mm 12mm;
  }
  @media print {
    html,
    body {
      margin: 0;
      padding: 0;
      overflow: visible !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      color-adjust: exact;
    }
    .prescription-print-root.print-container {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      margin: 0;
      padding: 0 !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    /* thead repeats at top each page; footer is fixed to physical bottom (see .prescription-print-footer-pin) */
    .prescription-print-root .prescription-print-layout {
      width: 100%;
      max-width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      table-layout: fixed;
    }
    .prescription-print-root thead {
      display: table-header-group;
    }
    .prescription-print-root thead tr {
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .prescription-print-root .prescription-print-thead-cell {
      padding: 0 0 10px 0;
      vertical-align: top;
    }
    .prescription-print-root .prescription-print-tbody-cell {
      padding: 8px 0 10px;
      vertical-align: top;
    }
    /* Last tbody row: keep with content above; avoid tall unbreakable row (was pushing sign alone to next page). */
    .prescription-print-root tr.prescription-print-sign-last-row {
      break-before: avoid;
      page-break-before: avoid;
    }
    .prescription-print-root .prescription-print-tbody-cell.prescription-print-sign-last {
      padding-top: 2mm;
      padding-bottom: 18mm;
      vertical-align: bottom;
      box-sizing: border-box;
    }
    .prescription-print-root .prescription-print-sign-inner {
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .prescription-print-root .prescription-print-doc-header {
      padding: 10px 8px 12px;
      margin: 0;
      text-align: center;
      box-sizing: border-box;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .prescription-print-root .prescription-print-doc-footer.prescription-print-footer-pin {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      padding: 6px 5mm 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      text-align: left;
      box-sizing: border-box;
      background: #fff;
      z-index: 9999;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .prescription-print-root .prescription-print-footer-inner {
      width: 100%;
      box-sizing: border-box;
    }
    .prescription-print-root .prescription-print-footer-doctor-name {
      margin-left: 0 !important;
    }
    .prescription-print-root
      .prescription-print-doc-footer.prescription-print-footer-pin
      .prescription-print-footer-disclaimer {
      align-self: center;
      width: 100%;
      text-align: center;
    }
    .prescription-print-root .prescription-print-footer-pin img {
      display: block;
      margin: 0;
      width: 100%;
      max-width: 100%;
      height: auto;
      vertical-align: bottom;
      object-fit: contain;
      object-position: bottom center;
    }
    .prescription-print-root .prescription-print-body-inner {
      padding: 2px 0 8px;
      box-sizing: border-box;
    }
    .prescription-print-root .prescription-print-patient-block,
    .prescription-print-root .prescription-print-top-block,
    .prescription-print-root .prescription-print-row,
    .prescription-print-root .prescription-print-col-head {
      break-inside: avoid;
      page-break-inside: avoid;
    }
    /* Long notes (discharge reports, etc.) must split across pages or page 1 is left empty */
    .prescription-print-root .prescription-print-notes {
      break-inside: auto;
      page-break-inside: auto;
    }
    /* PrescriptionView native table only — scoped; cert grids unchanged */
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table {
      display: table !important;
      width: 100% !important;
      max-width: 100% !important;
      border-collapse: collapse !important;
      table-layout: fixed !important;
      box-sizing: border-box;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      thead {
      display: table-header-group !important;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      tbody {
      display: table-row-group !important;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      tr {
      display: table-row !important;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      tr.prescription-print-notes-row {
      break-inside: auto;
      page-break-inside: auto;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      th,
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      td {
      display: table-cell !important;
      vertical-align: top;
      text-align: left;
      padding: 3px 4px;
      box-sizing: border-box;
      min-width: 0;
      max-width: 100%;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      thead
      th {
      border-bottom: 1px solid #000;
      padding-bottom: 4px;
    }
    /* Same WorkBookHistory column widths in print iframe */
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      .prescription-print-col-name {
      width: 25% !important;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      .prescription-print-col-dose {
      width: 12% !important;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      .prescription-print-col-freq {
      width: 13% !important;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      .prescription-print-col-route {
      width: 10% !important;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      .prescription-print-col-duration {
      width: 10% !important;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      .prescription-print-col-instructions {
      width: 15% !important;
    }
    .prescription-print-root
      .prescription-print-table
      > .prescription-print-native-table
      .prescription-print-col-remarks {
      width: 15% !important;
    }
    .prescription-print-root .prescription-print-row,
    .prescription-print-root .prescription-print-col-head {
      display: grid !important;
      grid-template-columns:
        minmax(0, 25fr)
        minmax(0, 12fr)
        minmax(0, 13fr)
        minmax(0, 10fr)
        minmax(0, 10fr)
        minmax(0, 15fr)
        minmax(0, 15fr);
      column-gap: 5px;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }
    .prescription-print-root .prescription-print-cell {
      min-width: 0;
      max-width: 100%;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
    .prescription-print-root img {
      max-width: 100%;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    /* Scoped only to FileView / BodyMapView — does not affect clinic logo, footer, or other print images */
    .prescription-print-root .file-view-root .file-view-item,
    .prescription-print-root .body-map-view-root .body-map-item {
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .prescription-print-root .file-view-root .file-view-image,
    .prescription-print-root .body-map-view-root .body-map-image {
      display: block !important;
      width: 40px !important;
      height: 40px !important;
      max-width: 40px !important;
      max-height: 40px !important;
      object-fit: contain !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .prescription-print-root .blue-box-examD,
    .prescription-print-root .p5 {
      break-inside: auto;
      page-break-inside: auto;
    }
    .prescription-print-root p,
    .prescription-print-root .MuiTypography-root {
      orphans: 3;
      widows: 3;
    }
    .print-container {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
    .prescription-print-hide-in-pdf {
      display: none !important;
    }
  }
`;

/** Keeps Certificate of Vaccination layout identical on screen and in Print/PDF */
export const vaccineCertPrintConfig = `
  @page {
    size: A4 portrait;
    margin: 10mm;
  }
  @media print {
    html,
    body {
      margin: 0 !important;
      padding: 0 !important;
      overflow: visible !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    .print-container,
    .vaccine-cert-print-root {
      position: relative !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
      background: #fff !important;
    }
    .vaccine-cert-no {
      position: static !important;
      display: block !important;
      text-align: right !important;
      font-size: 11px !important;
      color: #8a8a8a !important;
      margin: 0 4px 8px 0 !important;
    }
    .vaccine-cert-doc {
      display: block !important;
      position: relative !important;
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      border: 2px solid #0054a6 !important;
      border-radius: 10px !important;
      padding: 20px !important;
      background: #fff !important;
      color: #1a1a1a !important;
      page-break-inside: avoid;
      break-inside: avoid;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .vaccine-cert-brand {
      text-align: center !important;
      font-size: 18px !important;
      font-weight: 700 !important;
      color: #0054a6 !important;
      margin-top: 0 !important;
    }
    .vaccine-cert-title {
      text-align: center !important;
      font-size: 28px !important;
      font-weight: 700 !important;
      color: #0054a6 !important;
      margin: 6px 0 8px !important;
      letter-spacing: 0.2px !important;
    }
    .vaccine-cert-clinic-meta {
      text-align: center !important;
      font-size: 12px !important;
      color: #777 !important;
      margin-bottom: 22px !important;
    }
    .vaccine-cert-section-title {
      font-size: 13px !important;
      font-weight: 700 !important;
      color: #0054a6 !important;
      letter-spacing: 0.6px !important;
      margin-bottom: 10px !important;
    }
    .vaccine-cert-patient-grid {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      column-gap: 28px !important;
      row-gap: 8px !important;
      margin-bottom: 22px !important;
    }
    .vaccine-cert-field {
      display: flex !important;
      gap: 6px !important;
      font-size: 13px !important;
      line-height: 1.4 !important;
    }
    .vaccine-cert-field-label {
      color: #666 !important;
      white-space: nowrap !important;
    }
    .vaccine-cert-field-value {
      color: #111 !important;
      font-weight: 700 !important;
    }
    .vaccine-cert-table {
      width: 100% !important;
      border-collapse: collapse !important;
      margin-bottom: 18px !important;
      table-layout: auto !important;
    }
    .vaccine-cert-table thead {
      display: table-header-group !important;
    }
    .vaccine-cert-table tbody {
      display: table-row-group !important;
    }
    .vaccine-cert-table tr {
      display: table-row !important;
    }
    .vaccine-cert-table th,
    .vaccine-cert-table td {
      display: table-cell !important;
      text-align: left !important;
      vertical-align: top !important;
      padding: 8px 6px !important;
      box-sizing: border-box !important;
    }
    .vaccine-cert-table th {
      font-size: 12px !important;
      font-weight: 700 !important;
      color: #0054a6 !important;
      border-bottom: 1px solid #d0d0d0 !important;
    }
    .vaccine-cert-table td {
      font-size: 12px !important;
      color: #222 !important;
      border-bottom: 1px solid #ececec !important;
    }
    .vaccine-cert-statement {
      border: 1px solid #e0e0e0 !important;
      background: #f7f7f7 !important;
      border-radius: 6px !important;
      padding: 14px 18px !important;
      font-size: 12px !important;
      color: #555 !important;
      text-align: center !important;
      line-height: 1.55 !important;
      margin: 8px 0 28px !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .vaccine-cert-sign-wrap {
      margin-top: 100px !important;
      margin-bottom: 8px !important;
      box-sizing: border-box !important;
      padding-right: 0 !important;
      min-height: 0 !important;
      position: static !important;
    }
    .vaccine-cert-sign-row {
      display: flex !important;
      justify-content: space-between !important;
      align-items: flex-start !important;
      width: 100% !important;
      gap: 24px !important;
      margin-bottom: 0 !important;
    }
    .vaccine-cert-sign-block {
      width: 45% !important;
      max-width: 260px !important;
      min-width: 180px !important;
      flex: 0 1 auto !important;
    }
    .vaccine-cert-sign-left {
      text-align: left !important;
      margin-right: auto !important;
    }
    .vaccine-cert-sign-right {
      text-align: left !important;
      margin-left: auto !important;
      margin-right: 0 !important;
    }
    .vaccine-cert-sign-right .vaccine-cert-sign-line {
      margin-left: auto !important;
    }
    .vaccine-cert-sign-right .vaccine-cert-sign-name,
    .vaccine-cert-sign-right .vaccine-cert-sign-sub {
      text-align: right !important;
    }
    .vaccine-cert-sign-line {
      border-top: 1px solid #333 !important;
      width: 180px !important;
      margin-bottom: 6px !important;
    }
    .vaccine-cert-sign-name {
      font-size: 13px !important;
      font-weight: 700 !important;
      color: #111 !important;
    }
    .vaccine-cert-sign-sub {
      font-size: 11px !important;
      color: #666 !important;
      margin-top: 2px !important;
    }
    .vaccine-cert-footer {
      text-align: center !important;
      margin-top: 18px !important;
      padding-top: 10px !important;
      border-top: 1px solid #eee !important;
    }
    .vaccine-cert-footer-main {
      font-size: 11px !important;
      color: #666 !important;
      margin-bottom: 4px !important;
    }
    .vaccine-cert-footer-verify {
      font-size: 11px !important;
      color: #888 !important;
    }
  }
`;
